export default class User {
  constructor(username, nickname, password, checkPass) {
    this.username = username;
    this.nickname = nickname;
    this.password = password;
    this.checkPass = checkPass;
  }
}
